import { render } from "./CometChatUserProfile.vue?vue&type=template&id=cc2956b4&scoped=true"
import script from "./CometChatUserProfile.vue?vue&type=script&lang=js"
export * from "./CometChatUserProfile.vue?vue&type=script&lang=js"

import "./CometChatUserProfile.vue?vue&type=style&index=0&id=cc2956b4&scoped=true&lang=css"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc2956b4"]])

export default __exports__